import * as React from 'react';

export const hrFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_462)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_462'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_462)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V6.66667H0V0Z'
                    fill='#F93939'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill='#101097'
                />
                <mask
                    id='mask1_1_462'
                    style={{ maskType: 'alpha' }}
                    maskUnits='userSpaceOnUse'
                    x='10'
                    y='6'
                    width='8'
                    height='9'
                >
                    <path
                        d='M17.333 11.3333C17.333 13.1733 15.8397 14.6666 13.9997 14.6666C12.1597 14.6666 10.6663 13.1733 10.6663 11.3333V6.66664H17.333V11.3333Z'
                        fill='white'
                    />
                </mask>
                <g mask='url(#mask1_1_462)'>
                    <path
                        d='M17.3333 11.3333C17.3333 13.1733 15.84 14.6667 14 14.6667C12.16 14.6667 10.6667 13.1733 10.6667 11.3333V6.66667H17.3333V11.3333Z'
                        fill='#F93939'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M12 13.3333H13.3333V14.6667H12V13.3333ZM14.6667 13.3333H16V14.6667H14.6667V13.3333ZM13.3333 12H14.6667V13.3333H13.3333V12ZM12 10.6667H13.3333V12H12V10.6667ZM14.6667 10.6667H16V12H14.6667V10.6667ZM13.3333 9.33334H14.6667V10.6667H13.3333V9.33334ZM12 8.00001H13.3333V9.33334H12V8.00001ZM14.6667 8.00001H16V9.33334H14.6667V8.00001ZM13.3333 6.66667H14.6667V8.00001H13.3333V6.66667ZM16 6.66667H17.3333V8.00001H16V6.66667ZM16 9.33334H17.3333V10.6667H16V9.33334ZM16 12H17.3333V13.3333H16V12ZM10.6667 12H12V13.3333H10.6667V12ZM10.6667 9.33334H12V10.6667H10.6667V9.33334ZM10.6667 6.66667H12V8.00001H10.6667V6.66667Z'
                        fill='#F1F5F9'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M0 0H28V6.66667H0V0Z'
                        fill='#F93939'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M10.6667 5.33333H12V6.66667H10.6667V5.33333ZM13.3333 4H14.6667V6.66667H13.3333V4ZM16 5.33333H17.3333V6.66667H16V5.33333Z'
                        fill='#3A99FF'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M14.6667 4H16V6.66667H14.6667V4ZM12 4H13.3333V6.66667H12V4Z'
                        fill='#101097'
                    />
                </g>
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_462'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
